const rawSha = typeof __APP_GIT_SHA__ === 'string' ? __APP_GIT_SHA__ : ''
const resolvedSha = rawSha.trim().length > 0 ? rawSha : 'unknown'
const shortSha =
  resolvedSha === 'unknown' ? resolvedSha : resolvedSha.slice(0, 7)
const isDirty = Boolean(__APP_GIT_DIRTY__)

export const buildLabel = import.meta.env.DEV
  ? `${shortSha}${isDirty ? ' dirty' : ''}`
  : shortSha

// Released version this bundle was built from (CHANGELOG.json previousVersion);
// empty when built outside the release flow.
const rawVersion = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : ''
export const appVersion = rawVersion.trim()

// The served CHANGELOG.json carries the deployed version; comparing it against
// appVersion detects a deploy that this long-lived browser session predates.
export async function fetchServedAppVersion(): Promise<string | undefined> {
  try {
    const response = await fetch('/CHANGELOG.json', { cache: 'no-store' })
    if (!response.ok) return undefined
    const data = (await response.json()) as { previousVersion?: string }
    return data.previousVersion?.trim() || undefined
  } catch {
    return undefined
  }
}
